import ReactECharts from 'echarts-for-react';
import echarts from '../echarts';
import { ABILITY_DIMENSIONS, ABILITY_CURRENT, ABILITY_TARGET } from '../data/mockData';

// 区块2：师范生教学能力各维度平均得分 vs 理想目标值（柱状图）
export default function ChartBarAbility() {
  const option = {
    backgroundColor: 'transparent',
    title: {
      text: '师范生教学能力各维度平均得分 vs 理想目标值',
      left: 'center',
      textStyle: { color: '#fbbf24', fontSize: 20, fontWeight: 'bold' },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'shadow' },
      backgroundColor: 'rgba(15, 23, 42, 0.9)',
      borderColor: '#fbbf24',
      textStyle: { color: '#fff' },
    },
    legend: {
      data: ['当前平均水平', '理想目标值'],
      bottom: 0,
      textStyle: { color: '#cbd5e1', fontSize: 14 },
    },
    grid: { left: '3%', right: '4%', bottom: '12%', top: '18%', containLabel: true },
    xAxis: {
      type: 'category',
      data: ABILITY_DIMENSIONS,
      axisLine: { lineStyle: { color: '#475569' } },
      axisLabel: { color: '#e2e8f0', fontSize: 14, interval: 0 },
    },
    yAxis: {
      type: 'value',
      max: 100,
      axisLine: { lineStyle: { color: '#475569' } },
      axisLabel: { color: '#94a3b8', fontSize: 13 },
      splitLine: { lineStyle: { color: 'rgba(255,255,255,0.08)' } },
    },
    series: [
      {
        name: '当前平均水平',
        type: 'bar',
        data: ABILITY_CURRENT,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#06b6d4' },
            { offset: 1, color: '#0891b2' },
          ]),
          borderRadius: [6, 6, 0, 0],
        },
        barWidth: '30%',
        label: { show: true, position: 'top', color: '#fff', fontSize: 13 },
        animationDuration: 1200,
      },
      {
        name: '理想目标值',
        type: 'bar',
        data: ABILITY_TARGET,
        itemStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
            { offset: 0, color: '#fbbf24' },
            { offset: 1, color: '#d97706' },
          ]),
          borderRadius: [6, 6, 0, 0],
        },
        barWidth: '30%',
        label: { show: true, position: 'top', color: '#fff', fontSize: 13 },
        animationDuration: 1200,
        animationDelay: 300,
      },
    ],
  };

  return (
    <ReactECharts
      echarts={echarts}
      option={option}
      style={{ width: '100%', height: '100%', minHeight: 420 }}
      opts={{ renderer: 'svg' }}
    />
  );
}
